import { DATE_FORMAT } from "helpers/common";
import React from "react";

const Columns = ({ handleEditHandler }) => [
  {
    dataField: "coinName",
    text: "Coin",
    formatter: (_, row) => (
      <div className="d-flex align-items-center" style={{ gap: 5 }}>
        <img
          src={row?.coinIcon}
          alt=""
          className="img-fluid rounded-full object-fit-cover flex-shrink-0"
          style={{ height: 30, width: 30 }}
        />
        <span className="text-capitalize">{row?.coinName}</span>
      </div>
    ),
  },

  {
    dataField: "coinSymbol",
    text: "Coin Symbol",
    formatter: (_, row) => (
      <span className="text-capitalize">{row?.coinSymbol || "--"}</span>
    ),
  },
  // {
  //   dataField: "adminDetails",
  //   text: "Admin Email",
  //   formatter: (_, row) => (
  //     <span className="">{row?.adminDetails?.email || "--"}</span>
  //   ),
  // },
  // {
  //   dataField: "coinSymbol",
  //   text: "Admin Name",
  //   formatter: (_, row) => (
  //     <span className="">{row?.adminDetails?.name || "--"}</span>
  //   ),
  // },
  {
    dataField: "type",
    text: "Type",
    formatter: (_, row) => <span className="text">{row?.type || "--"}</span>,
  },
  {
    dataField: "newCoinBalance",
    text: "New Coin Balance",
    formatter: (_, row) => (
      <span className="text">{row?.newCoinBalance || "--"}</span>
    ),
  },
  {
    dataField: "prevCoinBalance",
    text: "Prev Coin Balance",
    formatter: (_, row) => (
      <span className="text">{row?.prevCoinBalance || "--"}</span>
    ),
  },

  {
    dataField: "amount",
    text: "Amount",
    formatter: (_, row) => <span className="text">{row?.amount || "--"}</span>,
  },
  // {
  //   dataField: "comment",
  //   text: "Comment",
  //   formatter: (_, row) => <span className="text">{row?.comment || "--"}</span>,
  // },
  {
    dataField: "transactionType",
    text: "Transaction Type",
    formatter: (_, row) => (
      <span className="text">{row?.transactionType || "--"}</span>
    ),
  },
  {
    dataField: "date_created_utc",
    text: "Created At",
    formatter: (_, row) => (
      <span className="text-capitalize">
        {row.date_created_utc && DATE_FORMAT(row.date_created_utc || "--")}
      </span>
    ),
  },
  {
    text: "Action",
    dataField: "status",
    formatter: (_, row) => (
      <button
        className="fas fa-eye"
        style={{
          fontSize: "16px",
          backgroundColor: "#fff",
          border: "none",
        }}
        title="Edit"
        onClick={() => handleEditHandler(row)}
      ></button>
    ),
  },
];
export default Columns;
